export default {
  apiKey: "AIzaSyCEVpJdtORwHam18S3JBSZm9mGA__G3_ZI",
  authDomain: "hisab-be04e.firebaseapp.com",
  projectId: "hisab-be04e",
  storageBucket: "hisab-be04e.firebasestorage.app",
  messagingSenderId: "1007341625589",
  appId: "1:1007341625589:web:7b76acac917353086865bc",
};
